module.exports = __webpack_public_path__ + "img/bkash.0800a8b7.png";